import Vue from "vue";
import Generator from "./generator.vue";
import SmoothScroll from "smooth-scroll";
import Axios from "axios";

var scroll = new SmoothScroll("[data-scroll]", {
  offset: -100
});

export const vueApp = new Vue({
  el: "#generator",
  components: {
    Generator
  },
  async created() {}
});



// WEBPACK FOOTER //
// ./scripts/generator.js